// Estilos consistentes para items del menú lateral
export const menuItemStyles = {
  // Estilo para item principal del menú
  menuItem: {
    mx: 1,
    my: 0.5,
    borderRadius: 2,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: 'rgba(25, 118, 210, 0.08)',
      transform: 'translateX(4px)',
    },
  },

  // Estilo para item de submenu
  subMenuItem: {
    mx: 1,
    my: 0.3,
    pl: 4,
    borderRadius: 2,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: 'rgba(25, 118, 210, 0.05)',
      transform: 'translateX(4px)',
    },
  },

  // Estilo para el icono
  menuIcon: {
    minWidth: 40,
    color: 'primary.main',
  },

  // Estilo para el texto
  menuText: {
    '& .MuiListItemText-primary': {
      fontWeight: 600,
      color: 'text.primary',
      fontSize: '0.9rem',
    },
  },

  // Estilo para texto de submenu
  subMenuText: {
    '& .MuiListItemText-primary': {
      fontWeight: 500,
      color: 'text.secondary',
      fontSize: '0.85rem',
    },
  },

  // Estilo para grupo expandible
  expandableHeader: {
    mx: 1,
    my: 0.5,
    borderRadius: 2,
    transition: 'all 0.2s ease',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(25, 118, 210, 0.08)',
    },
  },
};

export default menuItemStyles;
